import React from 'react';

import { Button } from '@swyftx/aviary/atoms/Button';
import { Card as AviaryCard } from '@swyftx/aviary/atoms/Card';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { Cross } from '@swyftx/aviary/icons/outlined';

import { GettingStartedCardType } from './useCards';
import { useResources } from './useResources';

const Card: React.FC<GettingStartedCardType> = ({ icon, title, content, onClick, id }) => {
  const { dismiss, isLoading } = useResources(id);

  const onDismiss = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    dismiss([id]);
  };

  return (
    <AviaryCard
      className='grid w-full cursor-pointer grid-cols-[auto_1fr_auto] gap-12 p-16 transition-colors hover:bg-color-background-surface-hover'
      onClick={onClick}
    >
      <div className='self-center'>{icon}</div>
      <div className='grid content-start gap-8'>
        <Body weight='emphasis' className='whitespace-wrap'>
          {title}
        </Body>
        <Body size='xsmall' color='secondary' className='min-h-[50px]'>
          {content}
        </Body>
      </div>
      <Button
        loading={isLoading}
        className='self-start'
        layout='icon'
        variant='filled'
        color='subtle'
        size='sm'
        onClick={(event) => onDismiss(event)}
      >
        <Cross className='h-12 w-12' />
      </Button>
    </AviaryCard>
  );
};

export default Card;
